import React from 'react';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import EmailScreenshot from './EmailScreenshot';
import {FormattedMessage, FormattedHTMLMessage, intlShape, injectIntl} from 'react-intl';
import hopscotch from 'hopscotch';
import events from 'lib/events';
import session from 'services/sessionService';
import Dealer from 'models/dealer';
import dealerApi from 'api/dealer';
import EmailPreferences from 'models/emailPreferences';
import emailApi from 'api/email';
import PageFooter from 'components/layout/pageFooter';
import FooterEditButton from 'components/layout/footerEditButton';
import LayoutCheckbox from 'components/forms/layoutCheckbox';
import {balanceColumns} from 'helpers/fieldHelpers';
import {formatCurrency} from 'helpers/currencyHelper';
import {dealerAdminTourFormat, userLevels, countries} from 'helpers/constants';
import {formatTwoDecimals} from 'helpers/numberFormatter';

class CustomerPreferences extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    dealer: new Dealer({}),
    dealerWorkingCopy: new Dealer({}),
    edit: false,
  };

  componentDidMount() {
    this.fetchData();
    if (hopscotch.getState() === 'dealerAdmin:11') {
      hopscotch.startTour(dealerAdminTourFormat(this.props.intl.formatMessage), 11);
    }
    if (hopscotch.getState() === 'dealerAdmin:12') {
      hopscotch.startTour(dealerAdminTourFormat(this.props.intl.formatMessage), 12);
    }
  }

  componentWillUnmount() {
    if (hopscotch.isActive && window.location.hash !== '#settings/store' && window.location.hash !== '#settings/water-analysis') {
      hopscotch.endTour();
    }
  }

  getEmailFollowUpOptions = () => {
    let problemFollowup = [];
    let {formatMessage} = this.props.intl;
    let prefs = this.state.preferencesWorkingCopy;

    if (prefs !== undefined) {
      problemFollowup.push(<LayoutCheckbox label={formatMessage({id: 'preferences.algae.in.spa'})}
                                           dataKey='algaeInSpa'
                                           key='algaeInSpa'
                                           data-event-category='User'
                                           data-event-action='check-algae-in-spa'
                                           value={prefs.algaeInSpa}
                                           editMode={this.state.edit}
                                           dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox label={formatMessage({id: 'preferences.metal.staining'})}
                                           dataKey='metalStaining'
                                           key='metalStaining'
                                           data-event-category='User'
                                           data-event-action='check-metalStaining'
                                           value={prefs.metalStaining}
                                           editMode={this.state.edit}
                                           dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox
        label={formatMessage({id: 'general.algae'}) + ' (' + formatMessage({id: 'general.black'}) + ')'}
        dataKey='algaeBlack'
        key='algaeBlack'
        data-event-category='User'
        data-event-action='check-algaeblack'
        value={prefs.algaeBlack}
        editMode={this.state.edit}
        dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox label={formatMessage({id: 'preferences.other.staining'})}
                                           dataKey='otherStaining'
                                           key='otherStaining'
                                           data-event-category='User'
                                           data-event-action='check-otherStaining'
                                           value={prefs.otherStaining}
                                           editMode={this.state.edit}
                                           dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox
        label={formatMessage({id: 'general.algae'}) + ' (' + formatMessage({id: 'general.green'}) + ')'}
        dataKey='algaeGreen'
        key='algaeGreen'
        data-event-category='User'
        data-event-action='check-algaegreen'
        value={prefs.algaeGreen}
        editMode={this.state.edit}
        dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox label={formatMessage({id: 'preferences.scale'})}
                                           dataKey='scale'
                                           key='scale'
                                           data-event-category='User'
                                           data-event-action='check-scale'
                                           value={prefs.scale}
                                           editMode={this.state.edit}
                                           dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox
        label={formatMessage({id: 'general.algae'}) + ' (' + formatMessage({id: 'general.mustard'}) + ')'}
        dataKey='algaeMustard'
        key='algaeMustard'
        value={prefs.algaeMustard}
        editMode={this.state.edit}
        data-event-category='User'
        data-event-action='check-algaemustard'
        dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox label={formatMessage({id: 'preferences.slime.mold'})}
                                           dataKey='slimeMold'
                                           key='slimeMold'
                                           data-event-category='User'
                                           data-event-action='check-slimeMold'
                                           value={prefs.slimeMold}
                                           editMode={this.state.edit}
                                           dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox label={formatMessage({id: 'preferences.chlorine.demand'})}
                                           dataKey='chlorineDemand'
                                           key='chlorineDemand'
                                           value={prefs.chlorineDemand}
                                           editMode={this.state.edit}
                                           data-event-category='User'
                                           data-event-action='check-chlorineDemand'
                                           dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox label={formatMessage({id: 'preferences.swampy'})}
                                           dataKey='swampy'
                                           key='swampy'
                                           data-event-category='User'
                                           data-event-action='check-swampy'
                                           value={prefs.swampy}
                                           editMode={this.state.edit}
                                           dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox label={formatMessage({id: 'preferences.cloudy.hazy.water'})}
                                           dataKey='cloudyOrHazyWater'
                                           key='cloudyOrHazyWater'
                                           value={prefs.cloudyOrHazyWater}
                                           editMode={this.state.edit}
                                           data-event-category='User'
                                           data-event-action='check-cloudyOrHazyWater'
                                           dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox label={formatMessage({id: 'preferences.waterline.buildup'})}
                                           dataKey='waterlineBuildup'
                                           key='waterlineBuildup'
                                           data-event-category='User'
                                           data-event-action='check-waterlineBuildup'
                                           value={prefs.waterlineBuildup}
                                           editMode={this.state.edit}
                                           dataChanged={this.dataChanged}/>);

      problemFollowup.push(<LayoutCheckbox label={formatMessage({id: 'preferences.foaming'})}
                                           dataKey='foaming'
                                           key='foaming'
                                           value={prefs.foaming}
                                           editMode={this.state.edit}
                                           data-event-category='User'
                                           data-event-action='check-foaming'
                                           dataChanged={this.dataChanged}/>);

      problemFollowup = problemFollowup.map(x => {
        return <div key={x.props.dataKey}
                    className='view-screenshot-wrapper'>
          {x}<EmailScreenshot title={formatMessage({id: `emails.${x.props.dataKey}.name`})}
                              name={x.props.dataKey}/>
        </div>;
      });

      problemFollowup.push(<div className='col-xs-4'/>);

      return balanceColumns(problemFollowup, 2);
    }
    return '';
  };

  formatEmailOptionWithDescription = (emailCheckbox, noScreenshot = false, copyDescription = null) => {
    let {formatMessage} = this.props.intl;

    if(noScreenshot) {
      return <div className="email-option" key={emailCheckbox.props.dataKey}>
        {emailCheckbox}
        {!!copyDescription ? <p className="preference-email-description">{copyDescription}</p> : null}
      </div>;
    }

    return <div className="email-option" key={emailCheckbox.props.dataKey}>
      <div className='view-screenshot-wrapper'>
        {emailCheckbox}<EmailScreenshot title={formatMessage({id: `emails.${emailCheckbox.props.dataKey}.name`})}
                        name={emailCheckbox.props.dataKey}/>
      </div>
      {!!copyDescription ? <p className="preference-email-description">{copyDescription}</p> : null}
    </div>;
  }

  getEmailsOtherNonOptionals = () => {
    let othersNotOptional = [];
    let {formatMessage} = this.props.intl;
    let prefs = this.state.preferencesWorkingCopy;

    if (prefs !== undefined) {
      othersNotOptional.push(this.formatEmailOptionWithDescription(<LayoutCheckbox label={formatMessage({id: 'preferences.new.customer.welcome'})}
                                             dataKey='newCustomerWelcome'
                                             key='newCustomerWelcome'
                                             data-event-category='User'
                                             data-event-action='check-newCustomerWelcome'
                                             value={prefs.newCustomerWelcome}
                                             editMode={false}
                                             dataChanged={this.dataChanged}/>,
                                             false,
                                             formatMessage({id: 'preferences.new-customer.welcome.email-description'})));

      othersNotOptional.push(this.formatEmailOptionWithDescription(<LayoutCheckbox label={formatMessage({id: 'preferences.existing.customer.welcome'})}
                                             dataKey='existingCustomerWelcome'
                                             key='existingCustomerWelcome'
                                             data-event-category='User'
                                             data-event-action='check-existingCustomerWelcome'
                                             value={true}
                                             editMode={false}
                                             dataChanged={this.dataChanged}/>,
                                             false,
                                             formatMessage({id: 'preferences.existing-customer.welcome.email-description'})));

      othersNotOptional.push(this.formatEmailOptionWithDescription(<LayoutCheckbox label={formatMessage({id: 'general.past.due'})}
                                             dataKey='pastDue'
                                             key='pastDue'
                                             data-event-category='User'
                                             data-event-action='check-pastDue'
                                             value={true}
                                             editMode={false}
                                             dataChanged={this.dataChanged}/>,
                                             false,
                                             formatMessage({id: 'preferences.past.due.email-description'})));

      othersNotOptional.push(this.formatEmailOptionWithDescription(<LayoutCheckbox label={formatMessage({id: 'preferences.inactive.client'})}
                                             dataKey='inactiveCustomer'
                                             key='inactiveCustomer'
                                             value={true}
                                             editMode={false}
                                             data-event-category='User'
                                             data-event-action='check-inactiveCustomer'
                                             dataChanged={this.dataChanged}/>,
                                             false,
                                             formatMessage({id: 'preferences.inactive.client.email-description'})));

      // [ALEX-2696] Remove all TruBlu emails
      // othersNotOptional.push(this.formatEmailOptionWithDescription(<LayoutCheckbox label={formatMessage({id: 'preferences.trublue.welcome'})}
      //                                        dataKey='trublueWelcome'
      //                                        key='trublueWelcome'
      //                                        value={true}
      //                                        editMode={false}
      //                                        data-event-category='User'
      //                                        data-event-action='check-trublueWelcome'
      //                                        dataChanged={this.dataChanged}/>,
      //                                        false,
      //                                        formatMessage({id: 'preferences.trublue.welcome.email-description'})));

      othersNotOptional.push(<div className='col-xs-4'/>);

      return balanceColumns(othersNotOptional, 1);
    }
    return '';
  };




  getProfileSettings = () => {
    let fields = [];
    const {formatMessage} = this.props.intl;

    fields.push(
      <div className='form-group'>
        <label>
          <FormattedMessage id='preferences.required.customer.information'/>
          {!this.state.edit ?
            <ToolTip title={formatMessage({id: 'preferences.valid.email.tooltip'})}
                     position={tooltipPositions.topRight}
                     iconOnly/> :
            null}
        </label>
        <LayoutCheckbox editMode={this.state.edit}
                        label={formatMessage({id: 'preferences.customer.email'})}
                        dataKey='requireCustomerEmail'
                        key='requireCustomerEmail'
                        data-event-category='User'
                        data-event-action='check-cust-email-req'
                        dataChanged={this.dataChanged}
                        value={this.state.dealerWorkingCopy.requireCustomerEmail}
                        className='email-checkbox'/>
      </div>
    );

    if (this.state.edit) {
      // [ALEX-2496] Remove "Auto-Inactive Customer Criteria" from dealer settings
      /* fields.push(
        <div className='form-group'>
          <label><FormattedMessage id='preferences.autoinactive.customer.criteria'/></label>
          <div style={{marginTop: '10px'}}>
            <label className='radio-inline'>
              <input type='radio'
                     name='customerInactiveTime'
                     defaultChecked={this.state.dealerWorkingCopy.customerInactiveTime > 0}/>
              <FormattedMessage id='general.last.analysis.date'/>
              <div className='form-group'
                   style={{marginTop: '10px'}}>
                <select className='form-control'
                        ref={r => this.customerInactiveTime = r}
                        defaultValue={this.state.dealerWorkingCopy.customerInactiveTime}>
                  <option value={18}>{formatMessage({id: 'general.months.ago'}, {n: 18})}</option>
                  <option value={24}>{formatMessage({id: 'general.months.ago'}, {n: 24})}</option>
                  <option value={30}>{formatMessage({id: 'general.months.ago'}, {n: 30})}</option>
                  <option value={36}>{formatMessage({id: 'general.months.ago'}, {n: 36})}</option>
                </select>
              </div>
            </label>
          </div>
          <div>
            <label className='radio-inline'>
              <input type='radio'
                     name='customerInactiveTime'
                     ref={r => this.customerInactiveTimeOff = r}
                     defaultChecked={this.state.dealerWorkingCopy.customerInactiveTime < 0}/>
              <FormattedMessage id='preferences.none.auto.inactivate'/>
            </label>
          </div>
        </div>
      ); */

      fields.push(
        <div className='form-group'>
          <label><FormattedMessage id='preferences.customer.spending.threshold'/></label>
          <div style={{marginTop: '10px'}}>
            <label className='radio-inline'>
              <input type='radio'
                     name='customerLoyaltyThresholdType'
                     defaultChecked={this.state.dealerWorkingCopy.customerLoyaltyThreshold !== null}/>
              <FormattedMessage id='preferences.specific.threshold'/> ($)

              <div className='form-group'
                   style={{marginTop: '10px'}}>
                <input type='number'
                       className='form-control'
                       name='customerLoyaltyThreshold'
                       ref={r => this.customerLoyaltyThresholdValue = r}
                       defaultValue={formatTwoDecimals(this.state.dealerWorkingCopy.customerLoyaltyThreshold)}/>
              </div>
            </label>
          </div>
          <div>
            <label className='radio-inline'>
              <input type='radio'
                     name='customerLoyaltyThresholdType'
                     ref={r => this.customerLoyaltyThresholdTypeOff = r}
                     defaultChecked={this.state.dealerWorkingCopy.customerLoyaltyThreshold === null}/>
              <FormattedMessage id='preferences.loyalty.median.spending'/>
            </label>
          </div>
        </div>
      );

      fields.push(
        <div className='form-group'>
          <label><FormattedMessage id='preferences.name.maintenance.program'/></label>
          <div style={{marginTop: '10px'}}>
            <input maxLength='25'
                   className='form-control'
                   name='customerLoyaltyThreshold'
                   ref={r => this.customerNameMaintenanceProgram = r}
                   defaultValue={this.state.dealerWorkingCopy.nameMaintenanceProgram}/>
          </div>
        </div>
      );

    } else {
      // [ALEX-2496] Remove "Auto-Inactive Customer Criteria" from dealer settings
      /* let label = formatMessage({id: 'preferences.none.auto.inactivate'});
      let value = false;

      if (this.state.dealerWorkingCopy.customerInactiveTime > 0) {
        label = `Last Analysis Date: ${this.state.dealerWorkingCopy.customerInactiveTime} months ago`;
        value = true;
      }

      fields.push(
        <div className='form-group'>
          <label>
            <FormattedMessage id='preferences.autoinactive.customer.criteria'/>
            <ToolTip title={formatMessage({id: 'preferences.range.criteria.tooltip'})}
                     position={tooltipPositions.topRight}
                     iconOnly/>
          </label>
          <LayoutCheckbox editMode={this.state.edit}
                          label={label}
                          dataKey='customerInactiveTime'
                          key='customerInactiveTime'
                          dataChanged={this.dataChanged}
                          value={value}/>
        </div>
      ); */

      fields.push(
        <div className='form-group'>
          <label>
            <FormattedMessage id='preferences.customer.spending.threshold'/>
            <ToolTip title={formatMessage({id: 'preferences.loyalty.customers.tooltip'})}
                     position={tooltipPositions.topRight}
                     iconOnly/>
          </label>
          <LayoutCheckbox
            editMode={this.state.edit}
            label={
              this.state.dealerWorkingCopy.customerLoyaltyThreshold === null ?
                formatMessage({id: 'preferences.customer.median.spending'}) :
                formatCurrency(parseFloat(this.state.dealerWorkingCopy.customerLoyaltyThreshold))
            }
            dataKey='customerLoyaltyThreshold'
            key='customerLoyaltyThreshold'
            dataChanged={this.dataChanged}
            value={this.state.dealerWorkingCopy.customerLoyaltyThreshold !== null}/>
        </div>
      );

      let maintenanceProgram = this.state.dealerWorkingCopy && this.state.dealerWorkingCopy.nameMaintenanceProgram ?
        this.state.dealerWorkingCopy.nameMaintenanceProgram :
        formatMessage({id: 'preferences.scheduled.maintenance'});

      fields.push(
        <div className='form-group'>
          <label>
            <FormattedMessage id='preferences.name.maintenance.program'/>
            <ToolTip title={formatMessage({id: 'preferences.name.maintenance.tooltip'})}
                     position={tooltipPositions.topRight}
                     iconOnly/>
          </label>
          <br/>
          <div className='form-control-static'>{maintenanceProgram}</div>
        </div>
      );
    }
    return <div className='col-xs-12'>
      {balanceColumns(fields, 3)}
    </div>;
  };

  cancelEdit = () => {
    this.setState({
      edit: false,
      dealerWorkingCopy: this.state.dealer.clone(),
      preferencesWorkingCopy: this.state.preferences.clone(),
    });
  };

  dataChanged = e => {
    let dealer = this.state.dealerWorkingCopy;
    let prefs = this.state.preferencesWorkingCopy;

    dealer[e.key] = e.value;
    prefs[e.key] = e.value;

    this.setState({
      preferencesWorkingCopy: prefs,
      dealerWorkingCopy: dealer,
    });
  };

  fetchData = () => {
    let {formatMessage} = this.props.intl;
    let dealerID = session.getUser().dealerId;

    dealerApi.getDealer(dealerID)
      .then(newDealer => {
        this.setState({
          dealer: newDealer.clone(),
          dealerWorkingCopy: newDealer.clone(),
        });
      })
      .catch(e => {
        console.error(e);
        events.publish('error.user', {message: formatMessage({id: 'general.error.retrieve.data'})});
      });
    emailApi.getPreferences(dealerID, true)
      .then(newPreferences => {
        this.setState({
          preferences: EmailPreferences.fromApiFormat(newPreferences).clone(),
          preferencesWorkingCopy: EmailPreferences.fromApiFormat(newPreferences).clone(),
        });
      })
      .catch(e => {
        console.error(e);
        events.publish('error.user', {message: formatMessage({id: 'general.error.retrieve.data'})});
      });
  };

  resetFollowUps = () => {
    let currentPrefs = this.state.preferences;
    let prefsWorkingCopy = this.state.preferencesWorkingCopy;

    prefsWorkingCopy.algaeInSpa = currentPrefs.algaeInSpa;
    prefsWorkingCopy.metalStaining = currentPrefs.metalStaining;
    prefsWorkingCopy.algaeBlack = currentPrefs.algaeBlack;
    prefsWorkingCopy.otherStaining = currentPrefs.otherStaining;
    prefsWorkingCopy.algaeGreen = currentPrefs.algaeGreen;
    prefsWorkingCopy.scale = currentPrefs.scale;
    prefsWorkingCopy.algaeMustard = currentPrefs.algaeMustard;
    prefsWorkingCopy.slimeMold = currentPrefs.slimeMold;
    prefsWorkingCopy.chlorineDemand = currentPrefs.chlorineDemand;
    prefsWorkingCopy.swampy = currentPrefs.swampy;
    prefsWorkingCopy.cloudyOrHazyWater = currentPrefs.cloudyOrHazyWater;
    prefsWorkingCopy.waterlineBuildup = currentPrefs.waterlineBuildup;
    prefsWorkingCopy.foaming = currentPrefs.foaming;
    this.setState({preferencesWorkingCopy: prefsWorkingCopy});
  };

  resetOptionals = () => {
    let currentPrefs = this.state.preferences;
    let prefsWorkingCopy = this.state.preferencesWorkingCopy;

    prefsWorkingCopy.winterProductReminder = currentPrefs.winterProductReminder;
    prefsWorkingCopy.poolClosingReminder = currentPrefs.poolClosingReminder;
    prefsWorkingCopy.memorialDayReminder = currentPrefs.memorialDayReminder;
    prefsWorkingCopy.fourthOfJulyReminder = currentPrefs.fourthOfJulyReminder;
    prefsWorkingCopy.labourDayReminder = currentPrefs.labourDayReminder;
    prefsWorkingCopy.victoriaDayReminder = currentPrefs.victoriaDayReminder;
    prefsWorkingCopy.canadaDayReminder = currentPrefs.canadaDayReminder;

    this.setState({preferencesWorkingCopy: prefsWorkingCopy});
  };

  savePrefs = () => {
    let saveApis = [];
    let dealer = this.state.dealerWorkingCopy;

    dealer.customerLoyaltyThreshold = this.customerLoyaltyThresholdTypeOff.checked ?
      null :
      parseFloat(this.customerLoyaltyThresholdValue.value);

    // [ALEX-2496] Remove "Auto-Inactive Customer Criteria" from dealer settings
    // dealer.customerInactiveTime = this.customerInactiveTimeOff.checked ?
    //   -1 :
    //   this.customerInactiveTime.value;

    dealer.nameMaintenanceProgram = this.customerNameMaintenanceProgram.value;

    let preferences = this.state.preferencesWorkingCopy;

    this.setState({
      preferencesWorkingCopy: preferences,
      dealerWorkingCopy: dealer,
    });

    saveApis.push(dealerApi.saveDealer(dealer));
    saveApis.push(emailApi.savePreferences(preferences));

    Promise.all(saveApis)
      .then(([newDealer, newPrefs]) => {
        this.setState({
          edit: false,
          dealer: newDealer.clone(),
          dealerWorkingCopy: newDealer.clone(),
          preferences: newPrefs.clone(),
          preferencesWorkingCopy: newPrefs.clone(),
        });
      })
      .catch(err => console.error(err));
  };

  startEdit = () => this.setState({edit: true});

  render() {
    let profileSettings = this.getProfileSettings();
    let triggeredEmails;
    let footer;
    let {formatMessage} = this.props.intl;

    if (session.getUser().privileges.level >= userLevels.manager) {
      triggeredEmails =
        <div>
          <h2 className='with-keyline'>
            <FormattedMessage id='preferences.system.triggered.emails'/>
            <ToolTip title={formatMessage({id: 'preferences.triggered.emails.tooltip'})}
                     position={tooltipPositions.topRight}
                     iconOnly
                     style={{float: 'right'}}/>
          </h2>
          <div className='col-xs-12'>
            <p style={{marginBottom: 40}}><FormattedMessage
              id='preferences.select.emails.automatically'/> (noreply@bioguard.com).</p>
            <div className='row'>
              <div className='col-sm-8'>
                <div className='form-group'>
                  <div className='row'>
                    <div className='col-sm-11'
                         style={{paddingLeft: '10px', paddingRight: '0px'}}>
                      <div className='form-group'>
                        <h4><FormattedMessage id='preferences.problem.followup'/> <span
                          className='heading-span'>(<FormattedMessage id='general.optional'/>)</span></h4>
                        <hr/>
                      </div>
                    </div>
                    <div className='col-sm-1'
                         style={{paddingLeft: '0px', paddingRight: '0px'}}>
                      <div className='form-group'>
                        {this.state.edit && session.getUser().isDealerAdmin ?
                          <h6 className='pointer'
                              onClick={() => this.resetFollowUps()}>
                            <FormattedMessage id='general.reset'/>
                          </h6> :
                          null}
                      </div>
                    </div>
                  </div>
                  {this.getEmailFollowUpOptions()}
                  <p className="preference-email-description"><FormattedHTMLMessage id="preferences.problem.followup.email-description"/></p>
                </div>
              </div>
              <div className='col-sm-4'>
                <div className='form-group'>
                  <div className='row'>
                    <div className='col-sm-10'
                         style={{paddingLeft: '10px', paddingRight: '0px'}}>
                      <div className='form-group'>
                        <h4><FormattedMessage id='general.other'/> <span className='heading-span'>(<FormattedMessage
                          id='general.required'/>)</span></h4>
                        <hr/>
                      </div>
                    </div>
                    <div className='col-sm-2'
                         style={{paddingLeft: '0px', paddingRight: '0px'}}>
                      <div className='form-group'>
                      </div>
                    </div>
                  </div>
                  {this.getEmailsOtherNonOptionals()}
                </div>
              </div>
            </div>
          </div>
        </div>;

      footer =
        <PageFooter>
          {session.getUser().isDealerAdmin ?
            <FooterEditButton className='footer-item'
                              onEdit={this.startEdit}
                              onCancel={this.cancelEdit}
                              onSave={this.savePrefs}
                              editMode={this.state.edit}/> :
            null}
        </PageFooter>;
    }

    return <div className='container'
                style={{paddingLeft: '0px', paddingRight: '20px'}}>
      <h2 className='with-keyline'><FormattedMessage id='preferences.profile.settings'/></h2>
      {profileSettings}
      {triggeredEmails}
      {footer}
    </div>;
  }
}

export default injectIntl(CustomerPreferences);
